// 正则校验
// 校验经纬度
const reg = /^-?\d+(\.\d+)?$/;
export const validLongitude = (rule, value, callback) => {
  if (value && !reg.test(value)) {
    callback(new Error('请输入有效的经度'));
    return;
  }
  if (value && !(Number(value) >= -180 && Number(value) <= 180)) {
    callback(new Error('经度范围在 -180 到 180 之间'));
    return;
  }
  callback();
};
export const validLatitude = (rule, value, callback) => {
  if (value && !reg.test(value)) {
    callback(new Error('请输入有效的纬度'));
    return;
  }
  if (value && !(Number(value) >= -90 && Number(value) <= 90)) {
    callback(new Error('纬度范围在 -90 到 90 之间'));
    return;
  }
  callback();
};

/**
 * 校验密码：密码长度在8-20位之间,由字母+数字+特殊字符组成
 * @param {string} value
 * @returns object
 */
export function verifyPass (value) {
  const reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,20}$/;
  if (!reg.test(value)) {
    return {
      isReg: false,
      regTxt: '密码长度在8-20位之间,由字母+数字+特殊字符组成'
    };
  }
  return { isReg: true, regTxt: '' };
}

/**
 * 流地址（协议类型）校验，必须以(rtsp/rtsps/rtmp/rtmps/hls/http/https)://开头
 * @param {string} value 
 */
export function verifyStream (value) {
  const reg = /^(rtsps?|rtmps?|hls|https?):(\/{2})(?!\/).*$/;
  return reg.test(value);
}


/**
 * 设备编码校验，设备编码为20位数字，请遵照国标编码规范重新填写
 * @param {string} value 
 */
export function verifyDeviceCode (value) {
  const reg = /^(?!.*(\d)\1{19})\d{20}$/;
  return reg.test(value) ? '' : '设备编号为20位数字，请遵照国标编码规范重新填写';
}

/**
 * 单位名称校验，单位名称中不能包含特殊字符
 * @param {string} value 
 */
export function verifyDept (value) {
  const reg = /[!@#$%^&*(),.?":{}|<>\/、]/g;
  if (reg.test(value)) {
    return {
      isReg: false,
      regTxt: '单位名称的格式不正确，不应包含任何特殊字符'
    };
  }
  return { isReg: true, regTxt: '' };
}


// WEBPACK FOOTER //
// ./src/utils/validate.js